// frontend/src/utils/permissions.js

export function isAdmin(user) {
  return Number(user?.role || 0) >= 4;
}

export function userId(user) {
  return user?.id || user?._id;
}

export function isOwner(draft, user) {

  if (!draft || !user) return false;

  const numericUserId =
    typeof user.userId !== "undefined" ? Number(user.userId) : null;

  const isAuthor =
    numericUserId !== null &&
    draft.authorId !== undefined &&
    Number(draft.authorId) === numericUserId;

  const mongoIds = [user._id, user.id]
    .filter(Boolean)
    .map((v) => String(v));

  const isEditor =
    draft.editorId !== undefined &&
    mongoIds.includes(String(draft.editorId));

  return isAuthor || isEditor;
}

export function canAccessDraft(draft, user) {
  return isAdmin(user) || isOwner(draft, user);
}

// Editors/Admins move stage; authors cannot (tweak if your policy differs)
export function canManageStage(draft, user) {
  const uid = String(userId(user) ?? "");
  return isAdmin(user) || String(draft?.editorId ?? "") === uid;
}

export function canCommentOnDraft(draft, user) {
  return canAccessDraft(draft, user);
}
